/**
 * chat-widget.js — bulle de chat IA pour pelotongp.com
 *
 * Intégration minimale, dans theme.liquid juste avant </body> :
 *
 *   {{ 'chat-widget.css' | asset_url | stylesheet_tag }}
 *   <script src="{{ 'chat-widget.js' | asset_url }}" data-backend-url="https://TON-PROJET.vercel.app/api/chat" defer></script>
 *
 * (remplace l'URL par celle de ton backend une fois déployé sur Vercel)
 */
(function () {
  "use strict";

  var scriptTag = document.currentScript;
  var BACKEND_URL =
    (scriptTag && scriptTag.dataset.backendUrl) ||
    (window.PGP_CHAT_CONFIG && window.PGP_CHAT_CONFIG.backendUrl);

  if (!BACKEND_URL) {
    console.warn(
      "[peloton-chat] Aucune URL de backend configurée (data-backend-url manquant) — le widget ne démarre pas."
    );
    return;
  }

  // localStorage (et non sessionStorage) : l'historique doit survivre à une
  // navigation vers une autre page du site (ex. le client clique sur le
  // lien d'un produit envoyé par le bot) et pas seulement aux rechargements
  // de la même page — sessionStorage se réinitialise sur certains
  // changements de page, ce qui coupait la conversation en plein milieu.
  var STORAGE_KEY = "pgp_chat_history_v1";
  var VISITOR_ID_KEY = "pgp_chat_visitor_id_v1";
  // Date (ms) jusqu'à laquelle la petite bulle d'invitation reste masquée,
  // une fois fermée ou une fois le chat ouvert par le visiteur.
  var TEASER_HIDDEN_KEY = "pgp_chat_teaser_hidden_until_v1";
  var TEASER_DELAY_MS = 8000;
  var TEASER_PAUSE_MS = 7 * 24 * 60 * 60 * 1000;

  function loadHistory() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveHistory(history) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
    } catch (e) {
      /* stockage indisponible (navigation privée, etc.) — pas grave */
    }
  }

  // Identifiant visiteur stable, généré une seule fois et conservé dans
  // localStorage. Envoyé au backend avec chaque message : ça lui permet de
  // garder une copie de secours de l'historique côté serveur (Cloudflare
  // KV), au cas où le stockage local du navigateur serait vidé.
  function loadOrCreateVisitorId() {
    try {
      var existing = localStorage.getItem(VISITOR_ID_KEY);
      if (existing) return existing;
      var id =
        window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : "v-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
      localStorage.setItem(VISITOR_ID_KEY, id);
      return id;
    } catch (e) {
      return null; // stockage indisponible — le chat marche quand même, juste sans mémoire persistante
    }
  }

  function teaserAllowed() {
    try {
      var until = Number(localStorage.getItem(TEASER_HIDDEN_KEY) || 0);
      return !(until && Date.now() < until);
    } catch (e) {
      return true;
    }
  }

  function pauseTeaser() {
    try {
      localStorage.setItem(TEASER_HIDDEN_KEY, String(Date.now() + TEASER_PAUSE_MS));
    } catch (e) {
      /* stockage indisponible — la bulle pourra réapparaître, sans gravité */
    }
  }

  var history = loadHistory();
  var visitorId = loadOrCreateVisitorId();

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  // Transforme les URLs brutes du texte de l'IA en liens cliquables.
  function linkify(text) {
    var escaped = escapeHtml(text);
    return escaped.replace(
      /(https?:\/\/[^\s]+)/g,
      '<a href="$1" target="_blank" rel="noopener">$1</a>'
    );
  }

  function build() {
    var launcher = document.createElement("button");
    launcher.id = "pgp-chat-launcher";
    launcher.type = "button";
    launcher.setAttribute("aria-label", "Ouvrir le chat");
    // Icône + texte visible : une simple bulle ronde n'était pas reconnue
    // comme un chat par une partie des visiteurs.
    launcher.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>' +
      '<span class="pgp-launcher-label">Une question ?</span>';

    var panel = document.createElement("div");
    panel.id = "pgp-chat-panel";
    panel.innerHTML =
      '<div class="pgp-chat-header">' +
      "<div><strong>Peloton GP</strong><span>On répond en général tout de suite</span></div>" +
      '<button id="pgp-chat-close" aria-label="Fermer le chat">✕</button>' +
      "</div>" +
      '<div id="pgp-chat-messages"></div>' +
      '<form class="pgp-chat-form" id="pgp-chat-form">' +
      '<input id="pgp-chat-input" type="text" placeholder="Écris ton message…" autocomplete="off" />' +
      '<button type="submit">Envoyer</button>' +
      "</form>";

    document.body.appendChild(launcher);
    document.body.appendChild(panel);

    var messagesEl = panel.querySelector("#pgp-chat-messages");
    var formEl = panel.querySelector("#pgp-chat-form");
    var inputEl = panel.querySelector("#pgp-chat-input");
    var closeBtn = panel.querySelector("#pgp-chat-close");

    function addMessage(role, text) {
      var el = document.createElement("div");
      el.className = "pgp-msg " + (role === "user" ? "pgp-msg-user" : "pgp-msg-bot");
      el.innerHTML = role === "user" ? escapeHtml(text) : linkify(text);
      messagesEl.appendChild(el);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function showTyping() {
      var el = document.createElement("div");
      el.className = "pgp-typing";
      el.id = "pgp-chat-typing";
      el.innerHTML = "<span></span><span></span><span></span>";
      messagesEl.appendChild(el);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function hideTyping() {
      var el = document.getElementById("pgp-chat-typing");
      if (el) el.remove();
    }

    // Rejoue l'historique déjà stocké pour cette session (si l'utilisateur
    // rouvre le chat après avoir navigué sur une autre page).
    history.forEach(function (msg) {
      if (msg.role !== "user" && msg.role !== "assistant") return;
      var text = Array.isArray(msg.content)
        ? msg.content
            .filter(function (b) {
              return b.type === "text";
            })
            .map(function (b) {
              return b.text;
            })
            .join("\n")
        : msg.content;
      if (text) addMessage(msg.role === "user" ? "user" : "bot", text);
    });

    if (history.length === 0) {
      addMessage(
        "bot",
        "Salut 👋 Je suis l'assistant Peloton GP. Je peux répondre à tes questions sur la boutique, les produits ou le suivi d'une commande. Comment je peux t'aider ?"
      );
    }

    var sending = false;

    formEl.addEventListener("submit", function (e) {
      e.preventDefault();
      var text = inputEl.value.trim();
      if (!text || sending) return;

      addMessage("user", text);
      inputEl.value = "";
      sending = true;
      inputEl.disabled = true;
      showTyping();

      fetch(BACKEND_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: text, history: history, visitorId: visitorId }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Erreur réseau");
          return res.json();
        })
        .then(function (data) {
          hideTyping();
          if (data.error) {
            addMessage("bot", "Désolé, une erreur est survenue. Réessaie dans un instant.");
            return;
          }
          addMessage("bot", data.reply);
          history = data.history || history;
          saveHistory(history);
        })
        .catch(function () {
          hideTyping();
          addMessage("bot", "Désolé, je n'arrive pas à me connecter. Réessaie dans un instant.");
        })
        .finally(function () {
          sending = false;
          inputEl.disabled = false;
          inputEl.focus();
        });
    });

    // Petite bulle d'invitation : une seule fois tous les 7 jours, seulement
    // pour un visiteur qui n'a jamais utilisé le chat. Ni fenêtre bloquante
    // ni son : elle se ferme d'un clic et ne revient pas sur chaque page.
    var teaser = null;
    var teaserTimer = null;

    function removeTeaser() {
      if (teaserTimer) {
        clearTimeout(teaserTimer);
        teaserTimer = null;
      }
      if (teaser) {
        teaser.remove();
        teaser = null;
      }
    }

    function showTeaser() {
      teaserTimer = null;
      if (teaser || panel.classList.contains("pgp-open") || !teaserAllowed()) return;
      teaser = document.createElement("div");
      teaser.id = "pgp-chat-teaser";
      teaser.innerHTML =
        '<button type="button" class="pgp-teaser-open">' +
        "<strong>Une question sur un produit ?</strong>" +
        "<span>Compatibilité, taille, commande… écris-nous ici.</span>" +
        "</button>" +
        '<button type="button" class="pgp-teaser-close" aria-label="Masquer ce message">✕</button>';
      document.body.appendChild(teaser);
      teaser.querySelector(".pgp-teaser-open").addEventListener("click", open);
      teaser.querySelector(".pgp-teaser-close").addEventListener("click", function () {
        pauseTeaser();
        removeTeaser();
      });
    }

    if (history.length === 0 && teaserAllowed()) {
      teaserTimer = setTimeout(showTeaser, TEASER_DELAY_MS);
    }

    function open() {
      pauseTeaser();
      removeTeaser();
      panel.classList.add("pgp-open");
      inputEl.focus();
    }
    function close() {
      panel.classList.remove("pgp-open");
    }

    launcher.addEventListener("click", function () {
      panel.classList.contains("pgp-open") ? close() : open();
    });
    closeBtn.addEventListener("click", close);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", build);
  } else {
    build();
  }
})();
